export default "__VITE_ASSET__De7uqq$8__"